<template>
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.45 37.65L10.35 35.55L21.9 24L10.35 12.45L12.45 10.35L24 21.9L35.55 10.35L37.65 12.45L26.1 24L37.65 35.55L35.55 37.65L24 26.1L12.45 37.65Z" fill="inherit"/></svg>
</template>